import React from 'react';
import {Icon, Label} from "semantic-ui-react";

export default function Participant(props) {
    return <Label style={{cursor: props.disabled ? 'default' : 'pointer'}}
                  onClick={props.disabled ? () => {} : props.onClick}>
        {props.gender === 'MALE' && <Icon name='man'/>}
        {props.gender === 'FEMALE' && <Icon name='woman'/>}
        {props.gender !== 'FEMALE' && props.gender !== 'MALE' && <Icon name='user'/>}
        {props.firstName} {props.lastName}
        <Label.Detail>'{props.birthDate.substring(2, 4)}</Label.Detail>
    </Label>
}



// WEBPACK FOOTER //
// ./src/components/application/Participant.js